import moment from "moment";
import { pipGetProfile } from "../../../utils/pip";
import { useNavigate } from "react-router-dom";

const MyAccount = () => {
  const profileData = pipGetProfile();
  const navigate = useNavigate()

  return (
    <>
      <div className="">
        <h3 class="ct_fs_32 ct_switzer_bold mb-5">My Account</h3>

        {/* Profile header */}
        <div class="profile-header justify-content-between flex-wrap">
          <div className="d-flex align-items-center gap-3">
            <img
              src={profileData?.avatar_url || "/assets/img/user_profile.png"}
              alt="User"
              class="ct_profile_avatar_75"
            />
            <div>
              <div class="ct_text_clr_4B5563 mb-2">
                <svg
                  className="me-2"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.975 9.165C10.3752 8.8186 10.6962 8.39016 10.9162 7.90877C11.1361 7.42737 11.25 6.90428 11.25 6.375C11.25 5.38044 10.8549 4.42661 10.1517 3.72335C9.44839 3.02009 8.49456 2.625 7.5 2.625C6.50544 2.625 5.55161 3.02009 4.84835 3.72335C4.14509 4.42661 3.75 5.38044 3.75 6.375C3.74999 6.90428 3.86385 7.42737 4.08384 7.90877C4.30384 8.39016 4.62482 8.8186 5.025 9.165C3.9751 9.64041 3.08435 10.4081 2.45924 11.3764C1.83412 12.3447 1.5011 13.4725 1.5 14.625C1.5 14.8239 1.57902 15.0147 1.71967 15.1553C1.86032 15.296 2.05109 15.375 2.25 15.375C2.44891 15.375 2.63968 15.296 2.78033 15.1553C2.92098 15.0147 3 14.8239 3 14.625C3 13.4315 3.47411 12.2869 4.31802 11.443C5.16193 10.5991 6.30653 10.125 7.5 10.125C8.69347 10.125 9.83807 10.5991 10.682 11.443C11.5259 12.2869 12 13.4315 12 14.625C12 14.8239 12.079 15.0147 12.2197 15.1553C12.3603 15.296 12.5511 15.375 12.75 15.375C12.9489 15.375 13.1397 15.296 13.2803 15.1553C13.421 15.0147 13.5 14.8239 13.5 14.625C13.4989 13.4725 13.1659 12.3447 12.5408 11.3764C11.9157 10.4081 11.0249 9.64041 9.975 9.165V9.165ZM7.5 8.625C7.05499 8.625 6.61998 8.49304 6.24997 8.24581C5.87996 7.99857 5.59157 7.64717 5.42127 7.23604C5.25097 6.8249 5.20642 6.3725 5.29323 5.93605C5.38005 5.49959 5.59434 5.09868 5.90901 4.78401C6.22368 4.46934 6.62459 4.25505 7.06105 4.16823C7.4975 4.08142 7.9499 4.12597 8.36104 4.29627C8.77217 4.46657 9.12357 4.75496 9.37081 5.12497C9.61804 5.49498 9.75 5.92999 9.75 6.375C9.75 6.97174 9.51295 7.54403 9.09099 7.96599C8.66903 8.38795 8.09674 8.625 7.5 8.625ZM16.2825 6.8475C16.2128 6.7772 16.1298 6.72141 16.0384 6.68333C15.947 6.64526 15.849 6.62565 15.75 6.62565C15.651 6.62565 15.553 6.64526 15.4616 6.68333C15.3702 6.72141 15.2872 6.7772 15.2175 6.8475L13.7175 8.3475L13.2525 7.875C13.1828 7.8047 13.0998 7.74891 13.0084 7.71083C12.917 7.67276 12.819 7.65315 12.72 7.65315C12.621 7.65315 12.523 7.67276 12.4316 7.71083C12.3402 7.74891 12.2572 7.8047 12.1875 7.875C12.0478 8.01552 11.9694 8.20561 11.9694 8.40375C11.9694 8.60189 12.0478 8.79198 12.1875 8.9325L13.1925 9.9375C13.333 10.0772 13.5231 10.1556 13.7213 10.1556C13.9194 10.1556 14.1095 10.0772 14.25 9.9375L16.2525 7.935C16.3282 7.86699 16.3893 7.78428 16.432 7.69191C16.4748 7.59954 16.4983 7.49943 16.5011 7.39769C16.5039 7.29595 16.4859 7.19471 16.4484 7.10012C16.4108 7.00553 16.3544 6.91958 16.2825 6.8475V6.8475Z"
                    fill="#414853"
                  />
                </svg>
                SecurPoint user since{" "}
                {moment(profileData?.createdAt).format("MMMM YYYY")}
              </div>
              <div class="ct_text_clr_4B5563">
                <span className="ct_green_text">
                  {profileData?.active_listing ?? 0}
                </span>{" "}
                {profileData?.active_listing === 1
                  ? "Active Listing"
                  : "Active Listings"}
              </div>
            </div>
          </div>
          <button
            className="ct_green_bnt px-3 py-2"
            onClick={() => {
              navigate(`/account-setting/edit-profile`);
            }}
          >
            Edit Profile
          </button>
        </div>

        {/* Personal Info */}
        <div class="account-card">
          <div class="ct_fs_18 ct_fw_500 mb-2">Personal Info</div>

          <div class="info-grid">
            <div>
              <div class="info-label mb-1 ct_text_clr_4B5563">Full Name</div>
              <div class="info-value">{profileData?.full_name || "#N/A"}</div>
            </div>

            <div>
              <div class="info-label mb-1 ct_text_clr_4B5563">Email</div>
              <div class="info-value">{profileData?.email || "#N/A"}</div>
            </div>

            <div>
              <div class="info-label mb-1 ct_text_clr_4B5563">Phone</div>
              <div class="info-value">{profileData?.phone_no || "#N/A"}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Owner's Note */}
      {profileData?.notes && (
        <div class="account-card">
          <div class="card-title mb-3 ct_fs_18">Owner’s Note</div>
          <p class="owner-note mb-0 ct_para_scroll ct_custom_scroll">
            {profileData?.notes || "#N/A"}
            {/* {} */}
          </p>
        </div>
      )}
    </>
  );
};

export default MyAccount;
